export default __webpack_public_path__ + "static/media/ic-data-operator.d6d6b4f1.svg";